export default "__VITE_ASSET__BRSpZoXi__"